import { call } from '../../funcStore';

const styles = {
  footer: {
    padding: '16px 24px',
    textAlign: 'center',
    color: '#888',
    fontSize: '0.85rem',
  },
  createLink: {
    border: 'none',
    background: 'none',
    color: '#4b3f8f',
    fontSize: '0.85rem',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
};

function Footer() {
  const handleCreateClick = () => {
    call('app.navigateToCreate');
  };

  return (
    <footer style={styles.footer}>
      <button
        type="button"
        style={styles.createLink}
        onClick={handleCreateClick}
      >
        VTuberの方へ：自分のページを作る
      </button>
      <p>&copy; 2026 vfinder</p>
    </footer>
  );
}

export default Footer;
